import ConsumersList from './ConsumersList';
export default ConsumersList;
